import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MostRecentAvatars } from 'components/common/most-recent-avatars/MostRecentAvatars';
import { AvatarData } from 'components/common/most-recent-avatars/MostRecentAvatarTypes';
import SubSection from 'components/common/section/sub-section/SubSection';
import EmptyStateMessageBody from 'components/common/section/sub-section/EmptyStateMessageBody';
import { trackEmptyStartLearningClick } from 'analytics/badgesAnalytics';
import { LEARNING_BADGES_DEFAULT_URL } from 'constants/index';

const MostRecentCourses = ({
  isPersonalView,
  recentCoursesBadges,
  profileHasConsented,
}: {
  isPersonalView: boolean;
  recentCoursesBadges: AvatarData[];
  profileHasConsented: boolean;
}) => {
  const isRecentCoursesZero =
    recentCoursesBadges.length === 0 || !profileHasConsented;

  if (!isPersonalView && isRecentCoursesZero) {
    return null;
  }
  // https://learning.atlassian.com/catalog does not exist yet
  return (
    <div
      data-testid="most-recent-courses-container"
      css={[
        boxStyles,
        recentCoursesStyle,
        isRecentCoursesZero && emptyCoursesStyles,
      ]}
    >
      <SubSection title={'MOST RECENT COURSES'}>
        {isRecentCoursesZero ? (
          <EmptyStateMessageBody
            message="Complete a course to earn your first learning badge."
            linkTo={LEARNING_BADGES_DEFAULT_URL}
            linkType="external"
            sendAnalyticsEvent={() =>
              trackEmptyStartLearningClick(isPersonalView)
            }
            linkText="Start learning"
          />
        ) : (
          <MostRecentAvatars data={recentCoursesBadges} />
        )}
      </SubSection>
    </div>
  );
};

const boxStyles = css({
  width: '50%',
  borderRadius: token('border.radius'),
  borderWidth: token('border.width'),
  '@media (max-width: 768px)': {
    width: '100%',
  },
});

const recentCoursesStyle = css({
  order: 1,
});

const emptyCoursesStyles = css({
  order: 3,
});

export default MostRecentCourses;
